import actionTypes from '../../action-types'

export default (fromUserId, toUserId) => ({
  type: actionTypes.USER.RELATION_DELETE,
  payload: {
    fromUserId,
    toUserId,
  },
})
